var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRemove = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75986 3.89987H7.25986V3.39987V2.3332C7.25986 1.88419 7.41829 1.44855 7.71342 1.15342C8.00854 0.8583 8.44418 0.699869 8.8932 0.699869H13.1599C13.6089 0.699869 14.0445 0.858299 14.3396 1.15342L14.6932 0.799869L14.3396 1.15342C14.6348 1.44855 14.7932 1.88419 14.7932 2.3332V3.39987V3.89987H15.2932H21.1932V5.0332H20.6265H20.1265V5.5332V22.5999C20.1265 24.0779 18.9046 25.2999 17.4265 25.2999H4.62653C3.14851 25.2999 1.92653 24.0779 1.92653 22.5999V5.5332V5.0332H1.42653H0.859863V3.89987H6.75986ZM8.8932 1.8332H8.3932V2.3332V3.39987V3.89987H8.8932H13.1599H13.6599V3.39987V2.3332V1.8332H13.1599H8.8932ZM3.55986 5.0332H3.05986V5.5332V22.5999C3.05986 23.4677 3.75872 24.1665 4.62653 24.1665H17.4265C18.2943 24.1665 18.9932 23.4677 18.9932 22.5999V5.5332V5.0332H18.4932H3.55986ZM7.32653 19.9665H6.1932V9.2332H7.32653V19.9665ZM11.5932 19.9665H10.4599V9.2332H11.5932V19.9665ZM15.8599 19.9665H14.7265V9.2332H15.8599V19.9665Z",
    fill: "#D5121E",
    stroke: "#D5121E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRemove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/remove.c514160be284ef69dcd05f81abad6e40.svg";